import { destinations } from "../../data/specialTour";
import { ContentBand, Inner, KakaoButton, PageIntro, SectionHeader, SpecialTourLayout } from "./SpecialTourLayout";

const hokkaidoCourseSummaries = [
  {
    title: "0박 4시간 코스",
    summary: "오비히로 근교에서 부담 없이 붙이기 좋은 반일 관광",
    spots: "나카사츠나이무라, 마나베정원, 반에이 경마",
  },
  {
    title: "0박 8시간 코스",
    summary: "북해도다운 자연 풍경을 더 길게 보는 당일 관광",
    spots: "카미시호로, 아사히다케 로프웨이",
  },
  {
    title: "1박2일 코스",
    summary: "골프 전후 이동일을 활용한 숙박형 확장 일정",
    spots: "비에이, 후라노, 온천 지역 조합 가능",
  },
  {
    title: "2박3일·3박4일 코스",
    summary: "A/B/C 광역 루트로 북해도 일주형 관광까지 확장",
    spots: "삿포로, 오타루, 하코다테, 도야, 아사히카와",
  },
];

const hokkaidoDetailCourses = [
  {
    label: "0박 8시간 코스",
    title: "오비히로 - 비에이 / 아사히다케 - 비에이",
    image: "/special-tour-assets/hokkaido-detail-8h-obihiro-asahidake-biei.png",
    imageAlt: "북해도편 0박 8시간 오비히로 아사히다케 비에이 관광 상세 일정표",
    description: "오비히로 출발 비에이 단독 코스와 아사히다케 로프웨이+비에이 코스를 함께 비교할 수 있는 당일형 상세 코스입니다.",
  },
  {
    label: "1박2일 코스",
    title: "삿포로 - 아사히다케 - 비에이 - 오비히로",
    image: "/special-tour-assets/hokkaido-detail-1n2d-sapporo-asahidake-biei.png",
    imageAlt: "북해도편 1박2일 삿포로 아사히다케 비에이 오비히로 관광 상세 일정표",
    description: "신치토세공항과 삿포로 1박을 시작으로 아사히다케, 비에이, 오비히로를 잇는 산악 풍경 중심 코스입니다.",
  },
  {
    label: "1박2일 코스",
    title: "삿포로 - 오타루 - 비에이 - 오비히로",
    image: "/special-tour-assets/hokkaido-detail-1n2d-sapporo-otaru-biei.png",
    imageAlt: "북해도편 1박2일 삿포로 오타루 비에이 오비히로 관광 상세 일정표",
    description: "삿포로와 오타루 운하, 오르골 공방을 거쳐 비에이와 오비히로로 내려오는 관광 밀도 높은 1박2일 코스입니다.",
  },
  {
    label: "2박3일 코스",
    title: "삿포로 - 오타루 - 아사히다케 - 비에이 - 오비히로",
    image: "/special-tour-assets/hokkaido-detail-2n3d-sapporo-otaru-asahidake-biei.png",
    imageAlt: "북해도편 2박3일 삿포로 오타루 아사히다케 비에이 오비히로 관광 상세 일정표",
    description: "삿포로 1박, 오타루, 아사히다케 로프웨이, 비에이를 여유 있게 연결하는 북해도 확장 관광 코스입니다.",
  },
];

const hokkaidoTourSpots = [
  {
    title: "나카사츠나이무라",
    course: "0박 4시간 코스",
    image: "/special-tour-assets/hokkaido-tour-nakasatsunai.jpg",
    imageAlt: "나카사츠나이무라 숲길과 조형물",
    description: "오비히로 남쪽의 조용한 마을과 숲길을 묶어 라운드 전후 가볍게 쉬어 가기 좋은 코스입니다.",
  },
  {
    title: "마나베정원",
    course: "0박 4시간 코스",
    image: "/special-tour-assets/hokkaido-tour-manabe-garden.jpg",
    imageAlt: "마나베정원의 초록 정원길",
    description: "수목과 정원 산책이 중심이라 골프 후 피로가 큰 팀도 편하게 넣기 좋은 근교 관광지입니다.",
  },
  {
    title: "반에이 경마",
    course: "0박 4시간 코스",
    image: "/special-tour-assets/hokkaido-tour-banei.jpg",
    imageAlt: "반에이 경마장 외관 벽화",
    description: "오비히로 특유의 말 문화를 가까이서 볼 수 있는 현지 체험형 스폿입니다.",
  },
  {
    title: "카미시호로",
    course: "0박 8시간 코스",
    image: "/special-tour-assets/hokkaido-tour-kamishihoro.jpg",
    imageAlt: "카미시호로 고원 전망",
    description: "토카치 평야를 시원하게 내려다보는 드라이브 코스로, 북해도다운 개방감을 느끼기 좋습니다.",
  },
  {
    title: "아사히다케 로프웨이",
    course: "0박 8시간 코스",
    image: "/special-tour-assets/hokkaido-tour-asahidake.jpg",
    imageAlt: "아사히다케 산과 호수 풍경",
    description: "대설산 국립공원의 고산 풍경을 보는 코스로, 날씨와 이동 시간을 확인해 여유 있게 구성합니다.",
  },
];

const hokkaidoWideCourses = [
  {
    title: "A코스",
    subtitle: "북해도 중남부 - 서북부 3박4일",
    image: "/special-tour-assets/hokkaido-tour-map-a.jpg",
    imageAlt: "북해도 A코스 관광 지도",
    description: "오비히로에서 남서부와 서북부 방향으로 확장하는 3박4일 광역 관광 루트입니다.",
  },
  {
    title: "B코스",
    subtitle: "북해도 중남부 - 동북부 3박4일",
    image: "/special-tour-assets/hokkaido-tour-map-b.jpg",
    imageAlt: "북해도 B코스 관광 지도",
    description: "동북부 방향 관광지를 길게 묶어 북해도 이동 자체를 여행의 중심으로 만드는 루트입니다.",
  },
  {
    title: "C코스",
    subtitle: "북해도 중북부 2박3일",
    image: "/special-tour-assets/hokkaido-tour-map-c.jpg",
    imageAlt: "북해도 C코스 관광 지도",
    description: "비에이, 아사히다케, 온천 지역을 연결해 자연 풍경을 밀도 있게 보는 2박3일 루트입니다.",
  },
];

export function DestinationsPage() {
  return (
    <SpecialTourLayout>
      <PageIntro
        eyebrow="Tourist Spots"
        title="라운드만큼 기억에 남는 일본 관광지"
        body="골프 이후의 시간이 좋아야 여행 전체가 좋아집니다. 온천, 자연 전망, 현지 체험, 광역 관광 코스를 팀 성향에 맞춰 붙입니다."
        image="/special-tour-assets/hokkaido-winter-hero.png"
      />
      <ContentBand className="bg-white">
        <Inner>
          <SectionHeader
            eyebrow="Hokkaido Edition"
            title="북해도편: 시간별로 고르는 관광 코스"
            body="저희가 북해도 관광상품_코스별_시간별 자료를 확인해, 오비히로 출발 반일 코스부터 2박3일·3박4일 광역 루트까지 홈페이지용으로 다시 정리했습니다."
          />

          <div className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
            <div className="grid gap-4 sm:grid-cols-2">
              {hokkaidoCourseSummaries.map((course) => (
                <article key={course.title} className="rounded-lg border border-[#dce3d8] bg-[#fbfaf6] p-5 shadow-sm">
                  <div className="text-sm font-900 text-[#d16339]">{course.title}</div>
                  <h2 className="mt-2 text-xl font-900 leading-snug text-[#15391f] [word-break:keep-all]">{course.summary}</h2>
                  <p className="mt-3 text-sm leading-7 text-[#596559] [word-break:keep-all]">{course.spots}</p>
                </article>
              ))}
            </div>

            <div className="rounded-lg bg-[#15391f] p-6 text-white shadow-sm">
              <div className="text-sm font-900 uppercase tracking-normal text-[#f1c8aa]">Our Summary</div>
              <h2 className="mt-3 text-2xl font-900 leading-tight [word-break:keep-all]">저희가 현장 이미지 중심으로 구성한 4시간·8시간 코스</h2>
              <p className="mt-4 text-sm leading-7 text-white/78 [word-break:keep-all]">
                1박2일, 2박3일, 3박4일 일정은 확장 코스로 묶고, 실제 노출 이미지는 저희가 확인한 4시간·8시간 코스와 광역 지도 자료를 우선 반영했습니다.
              </p>
            </div>
          </div>

          <div className="mt-12">
            <SectionHeader
              title="코스별 상세 일정표"
              body="저희가 확인한 PNG 상세 자료 4장을 원본 비율로 삽입했습니다. 모바일에서도 내용이 잘리지 않도록 이미지 전체가 보이게 구성했습니다."
            />
            <div className="grid gap-6 lg:grid-cols-2">
              {hokkaidoDetailCourses.map((course) => (
                <article key={course.image} className="overflow-hidden rounded-lg border border-[#dce3d8] bg-[#fbfaf6] shadow-sm">
                  <div className="border-b border-[#dce3d8] bg-white p-5">
                    <div className="text-sm font-900 text-[#d16339]">{course.label}</div>
                    <h2 className="mt-2 text-2xl font-900 leading-tight text-[#15391f] [word-break:keep-all]">{course.title}</h2>
                    <p className="mt-3 text-sm leading-7 text-[#596559] [word-break:keep-all]">{course.description}</p>
                  </div>
                  <div className="bg-white p-3">
                    <img src={course.image} alt={course.imageAlt} className="h-auto w-full rounded-md border border-[#edf0ea]" />
                  </div>
                </article>
              ))}
            </div>
          </div>

          <div className="mt-8 grid gap-6 md:grid-cols-2 xl:grid-cols-5">
            {hokkaidoTourSpots.map((spot) => (
              <article key={spot.title} className="overflow-hidden rounded-lg border border-[#dce3d8] bg-[#fbfaf6] shadow-sm">
                <img src={spot.image} alt={spot.imageAlt} className="h-48 w-full object-cover" />
                <div className="p-5">
                  <div className="text-sm font-900 text-[#d16339]">{spot.course}</div>
                  <h2 className="mt-2 text-xl font-900 leading-snug text-[#15391f] [word-break:keep-all]">{spot.title}</h2>
                  <p className="mt-3 text-sm leading-7 text-[#596559] [word-break:keep-all]">{spot.description}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-12">
            <SectionHeader
              title="북해도 광역 관광 지도"
              body="장거리 이동을 포함하는 팀은 저희가 A/B/C 코스 지도를 함께 보며 골프 일정과 관광 동선을 조정해 드립니다."
            />
            <div className="grid gap-6 lg:grid-cols-3">
              {hokkaidoWideCourses.map((course) => (
                <article key={course.title} className="overflow-hidden rounded-lg border border-[#dce3d8] bg-white shadow-sm">
                  <div className="flex h-64 items-center justify-center bg-[#edf2e8] p-3">
                    <img src={course.image} alt={course.imageAlt} className="max-h-full w-full object-contain" />
                  </div>
                  <div className="p-5">
                    <div className="text-sm font-900 text-[#d16339]">{course.title}</div>
                    <h2 className="mt-2 text-xl font-900 leading-snug text-[#15391f] [word-break:keep-all]">{course.subtitle}</h2>
                    <p className="mt-3 text-sm leading-7 text-[#596559] [word-break:keep-all]">{course.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </Inner>
      </ContentBand>

      <ContentBand>
        <Inner>
          <SectionHeader title="지역별 추천 관광지" body="라운드 전후 일정에 더하면 여행의 색이 선명해지는 관광지입니다." />
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {destinations.map((destination) => (
              <article key={destination.title} className="overflow-hidden rounded-lg border border-[#dce3d8] bg-[#fbfaf6] shadow-sm">
                <img src={destination.image} alt={destination.imageAlt} className="h-64 w-full object-cover" />
                <div className="p-6">
                  <div className="text-sm font-900 text-[#d16339]">{destination.area}</div>
                  <h2 className="mt-2 text-2xl font-900 text-[#15391f]">{destination.title}</h2>
                  <p className="mt-3 text-sm leading-7 text-[#596559]">{destination.description}</p>
                </div>
              </article>
            ))}
          </div>
        </Inner>
      </ContentBand>

      <ContentBand>
        <Inner>
          <div className="grid gap-6 rounded-lg border border-[#dce3d8] bg-white p-6 shadow-sm md:grid-cols-[1fr_auto] md:items-center md:p-8">
            <div>
              <h2 className="text-3xl font-900 text-[#15391f]">골프 외 일정도 취향대로 조정합니다</h2>
              <p className="mt-4 max-w-3xl text-base leading-8 text-[#596559]">
                온천을 길게 넣거나, 저녁을 현지 이자카야 중심으로 잡거나, 비골퍼 동행자의 자유여행 동선을 따로
                설계할 수 있습니다.
              </p>
            </div>
            <KakaoButton label="관광지 상담하기" />
          </div>
        </Inner>
      </ContentBand>
    </SpecialTourLayout>
  );
}
